import { useEffect, useState } from 'react';
import { dismissToast, subscribeToasts, type Toast } from '../lib/toast.js';

export function Toaster() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    return subscribeToasts(setToasts);
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-80 flex-col gap-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`pointer-events-auto flex items-start justify-between gap-3 rounded-md border px-3 py-2 text-sm shadow-lg backdrop-blur ${kindClass(
            t.kind,
          )}`}
        >
          <span className="break-words">{t.message}</span>
          <button
            type="button"
            onClick={() => {
              dismissToast(t.id);
            }}
            className="text-xs opacity-60 hover:opacity-100"
            aria-label="dismiss"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}

function kindClass(kind: Toast['kind']): string {
  switch (kind) {
    case 'success':
      return 'border-emerald-500/40 bg-emerald-500/10 text-emerald-200';
    case 'error':
      return 'border-rose-500/40 bg-rose-500/10 text-rose-200';
    case 'info':
    default:
      return 'border-zinc-700 bg-zinc-900/90 text-zinc-200';
  }
}
